import React from 'react';
import apiRequest from '../../services/apiClient';
import { getCsrfToken } from '../../services/authService';
import logger from '../../services/logger';
import AdminToast from '../../components/AdminToast';
import AdminConfirmModal from '../../components/AdminConfirmModal';
import { formatAlgiersDateTime } from '../../../utils/dateTime';

const AdminMessages = () => {
    const [messages, setMessages] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState('');
    const [success, setSuccess] = React.useState('');
    const [selectedMessage, setSelectedMessage] = React.useState(null);
    const [deleteTarget, setDeleteTarget] = React.useState(null);
    const [messagePage, setMessagePage] = React.useState(1);
    const messagesPerPage = 10;

    React.useEffect(() => {
        apiRequest('/admin-messages/list.php')
            .then((response) => setMessages(response.data || []))
            .catch((requestError) => {
                setError(requestError.message);
                logger.error('RSVP messages load failed', { requestId: requestError.requestId });
            })
            .finally(() => setLoading(false));
    }, []);

    const confirmDeleteMessage = async (message) => {
        try {
            await apiRequest('/admin-messages/delete.php', { method: 'POST', headers: { 'X-CSRF-Token': getCsrfToken() }, body: JSON.stringify({ id: message.id }) });
            setMessages((current) => current.filter((item) => item.id !== message.id));
            setSuccess('Message supprimé.');
        } catch (requestError) {
            setError(requestError.message);
            logger.error('RSVP message delete failed', { requestId: requestError.requestId });
        }
    };

    const deleteMessage = (message) => setDeleteTarget(message);

    const totalPages = Math.max(1, Math.ceil(messages.length / messagesPerPage));
    const paginatedMessages = messages.slice((messagePage - 1) * messagesPerPage, messagePage * messagesPerPage);

    React.useEffect(() => {
        if (messagePage > totalPages) setMessagePage(totalPages);
    }, [messagePage, totalPages]);

    return (
        <div className="admin-page">
            <div className="admin-page-toolbar">
                <div>
                    <span className="admin-eyebrow">RÉPONSES RSVP</span>
                    <h1>Messages RSVP</h1>
                    <p>Consultez les réponses reçues depuis le formulaire public.</p>
                </div>
            </div>
            <AdminToast message={error} type="danger" onClose={() => setError('')} />
            <AdminToast message={success} type="success" onClose={() => setSuccess('')} />
            <section className="admin-card admin-messages-card">
                {loading ? <div className="admin-settings-loading">Chargement des messages…</div> : !messages.length ? <div className="admin-settings-loading">Aucun message.</div> : (
                    <><div className="admin-table-responsive">
                        <table className="admin-table admin-messages-table">
                            <thead><tr><th>Date</th><th>Nom</th><th>E-mail</th><th>Invités</th><th>Participation</th><th>Message</th><th className="text-right">Actions</th></tr></thead>
                            <tbody>{paginatedMessages.map((message) => <tr key={message.id}>
                                <td>{formatAlgiersDateTime(message.created_at)}</td>
                                <td><strong>{message.name}</strong></td>
                                <td className="admin-message-email"><a href={`mailto:${message.email}`}>{message.email}</a></td>
                                <td>{message.guest_count}</td>
                                <td>{message.event_selection}</td>
                                <td className="admin-message-cell">{message.message}</td>
                                <td className="text-right"><div className="admin-message-action-buttons"><button className="admin-icon-button info" title="Voir le message" type="button" onClick={() => setSelectedMessage(message)}><i className="fa fa-eye" /></button><button className="admin-icon-button danger" title="Supprimer" type="button" onClick={() => deleteMessage(message)}><i className="fa fa-trash" /></button></div></td>
                            </tr>)}</tbody>
                        </table>
                    </div><div className="admin-pagination"><span>Page {messagePage} sur {totalPages} · {messages.length} message(s)</span><div><button className="admin-button admin-button-light admin-button-small" type="button" disabled={messagePage <= 1} onClick={() => setMessagePage(messagePage - 1)}>Précédent</button><button className="admin-button admin-button-light admin-button-small" type="button" disabled={messagePage >= totalPages} onClick={() => setMessagePage(messagePage + 1)}>Suivant</button></div></div></>
                )}
            </section>
            {selectedMessage && <div className="admin-modal-backdrop" role="presentation"><div className="admin-modal admin-message-modal" role="dialog" aria-modal="true" aria-labelledby="message-modal-title"><div className="admin-modal-header"><div><span className="admin-eyebrow">MESSAGE RSVP</span><h2 id="message-modal-title">{selectedMessage.name}</h2></div><button className="admin-modal-close" type="button" onClick={() => setSelectedMessage(null)} aria-label="Fermer">×</button></div><div className="admin-message-modal-meta"><a href={`mailto:${selectedMessage.email}`}>{selectedMessage.email}</a><span>{selectedMessage.guest_count} invité(s)</span><span>{selectedMessage.event_selection}</span></div><p className="admin-message-modal-date">{formatAlgiersDateTime(selectedMessage.created_at)}</p><p className="admin-message-modal-content">{selectedMessage.message}</p></div></div>}
            <AdminConfirmModal isOpen={Boolean(deleteTarget)} title="Supprimer ce message ?" message={deleteTarget ? `La réponse RSVP de « ${deleteTarget.name} » sera définitivement supprimée.` : ''} onCancel={() => setDeleteTarget(null)} onConfirm={() => { const target = deleteTarget; setDeleteTarget(null); if (target) confirmDeleteMessage(target); }} />
        </div>
    );
};

export default AdminMessages;
